module.exports = __webpack_public_path__ + "assets/img/bake.35afb862.png";